module.exports = __webpack_public_path__ + "assets/dd95658186017575b3d6ba8cb2aff8fe.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet+3.mp3
 ** module id = 234
 ** module chunks = 0
 **/